export function debounce(func: Function, timeout?: number) {
  let timer: any
  return (...args: any[]) => {
    const next = () => func(...args)
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(next, timeout && timeout > 0 ? timeout : 300)
  }
}
